import axios from "axios";

const apiClient = axios.create({
  // baseURL: "http://localhost:3000/api/v1/",
  baseURL: "https://udapi.diskwala.com/api/v1/",
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth-token");
  if (token) config.headers["auth-token"] = token;
  return config;
});

const getErrorData = (error) => {
  if (error.response?.data) return error.response.data;
  if (error.message) return { msg: error.message };
  return { msg: "Network Error" };
};

const apiGet = async (url, params, callback) => {
  try {
    const response = await apiClient.get(url, params ? { params } : undefined);
    const result = { status: 200, data: response.data };
    if (callback) callback(result);
    return result;
  } catch (error) {
    const result = {
      status: error.response?.status || 400,
      data: getErrorData(error),
    };
    if (callback) callback(result);
    return result;
  }
};

const apiPost = async (url, data, callback, config) => {
  try {
    const response = await apiClient.post(url, data, config);
    const result = { status: 200, data: response.data };
    if (callback) callback(result);
    return result;
  } catch (error) {
    const result = {
      status: error.response?.status || 400,
      data: getErrorData(error),
    };
    if (callback) callback(result);
    return result;
  }
};

// Auth
export const auth = (callback) => apiGet("/admin/auth", null, callback);
export const APISignUp = (data, callback) =>
  apiPost("/admin/signup", data, callback);
export const APILogin = (data, callback) =>
  apiPost("/admin/login", data, callback);

// Google Ad Units
export const APIGetAdUnits = (callback) =>
  apiGet("/admin/adunits", null, callback);
export const APIUpdateAdUnits = (data, callback) =>
  apiPost("/admin/update_adunits", data, callback);
export const APIGetIOSAdUnits = (callback) =>
  apiGet("/admin/ios_adunits", null, callback);
export const APIUpdateIOSAdUnits = (data, callback) =>
  apiPost("/admin/update_ios_adunits", data, callback);

// AppLovin Ad Units
export const APIGetAdUnitsAL = (callback) =>
  apiGet("/admin/adunits_al", null, callback);
export const APIUpdateAdUnitsAL = (data, callback) =>
  apiPost("/admin/update_adunits_al", data, callback);
export const APIGetIOSAdUnitsAL = (callback) =>
  apiGet("/admin/ios_adunits_al", null, callback);
export const APIUpdateIOSAdUnitsAL = (data, callback) =>
  apiPost("/admin/update_ios_adunits_al", data, callback);

// CPM
export const APIUpdateCPM = (data, callback) =>
  apiPost("/admin/cpm", data, callback);
export const APIGet10CPM = (callback) => apiGet("/admin/cpm", null, callback);

// Withdrawals
export const APIGetRequests = (params, callback) =>
  apiGet("/admin/get_requests", params, callback);
export const APIGetWithdrawalByStatus = (params, callback) =>
  apiGet("/admin/get_requests_by_status", params, callback);
export const APIUpdateRequest = (data, callback) =>
  apiPost("/admin/update_request", data, callback);
export const APIReturnMoney = (data, callback) =>
  apiPost("/admin/return", data, callback);
export const APIRefreshWithdrawalStatus = (data, callback) =>
  apiPost("/admin/refresh_withdrawal_status", data, callback);
export const APIGetWithdrawalById = (params, callback) =>
  apiGet("/admin/getWithdrawalById", params, callback);
export const APISearchWithdrawal = (params, callback) =>
  apiGet("/admin/searchWithdrawal", params, callback);

// Revenue
export const APIGetDailyAnalytics = (data, callback) =>
  apiPost("/admin/daily", data, callback, { timeout: 60000 });

// Users
export const APIGetUsers = (callback) =>
  apiGet("/admin/getUsers", null, callback);
export const APIGetUserRevenue = (params, callback) =>
  apiGet("/admin/getUserRevenue", params, callback);
export const APIGetUserWithdrawal = (params, callback) =>
  apiGet("/admin/getUserWithdrawal", params, callback);
export const APIGetUser = (params, callback) =>
  apiGet("/admin/getUser", params, callback);
export const APIBlockUser = (params, callback) =>
  apiGet("/admin/block_user", params, callback);
export const APIUnBlockUser = (params, callback) =>
  apiGet("/admin/unblock_user", params, callback);

// Content Management
export const APIDeleteAllVideos = (data, callback) =>
  apiPost("/admin/delete_user_files", data, callback);
export const APIDeleteFile = (data, callback) =>
  apiPost("/admin/delete_file", data, callback);
export const APIGetFileDetails = (data, callback) =>
  apiPost("/file/min_info", data, callback);
export const APIDeleteCopyrightLinks = (data, callback) =>
  apiPost("/admin/delete_copyright", data, callback);

// Analytics
export const APIGetAllUserAnalytics = (callback) =>
  apiGet("/admin/get_user_analytics", null, callback);
export const APIGetIPRedisLogs = (callback) =>
  apiGet("/admin/getIPRedisLogs", null, callback);

// Verification
export const APIGetUnverifiedUsers = (callback) =>
  apiGet("/admin/unverified_account", null, callback);
export const APIUpdateUserVerification = (data, callback) =>
  apiPost("/admin/verification_action", data, callback);
